import { render, staticRenderFns } from "./timeLimit.vue?vue&type=template&id=d5c551a8&scoped=true"
import script from "./timeLimit.vue?vue&type=script&lang=js"
export * from "./timeLimit.vue?vue&type=script&lang=js"
import style0 from "./timeLimit.vue?vue&type=style&index=0&id=d5c551a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c551a8",
  null
  
)

export default component.exports